import React from 'react';
import { inputClass } from './BackgroundFields';

function Field({ label, children }) {
  return (
    <label className="block space-y-1.5">
      <span className="text-xs font-medium text-muted-foreground">{label}</span>
      {children}
    </label>
  );
}

function formatLetterSpacingEm(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || Math.abs(n) < 0.0001) return '0 (normal)';
  const pxHint = `${(n * 16).toFixed(1)} px`;
  return `${n.toFixed(3).replace(/\.?0+$/, '')} em (≈ ${pxHint} à 16px)`;
}

export default function TextBlockTypographyFields({ props, setProp }) {
  const letterSpacing = Number(props.letterSpacing) || 0;

  return (
    <div className="rounded-lg border border-border p-3 space-y-3 bg-muted/10">
      <p className="text-xs font-semibold text-foreground">Typographie du bloc</p>
      <Field label={`Interlettrage — ${formatLetterSpacingEm(letterSpacing)}`}>
        <input
          type="range"
          min={-0.08}
          max={0.45}
          step={0.005}
          className="w-full"
          value={letterSpacing}
          onChange={(e) => setProp('letterSpacing', Number(e.target.value))}
        />
      </Field>
      <div className="flex items-center gap-2">
        <input
          type="number"
          step={0.01}
          min={-0.08}
          max={0.45}
          className={`${inputClass} max-w-[7rem]`}
          value={letterSpacing}
          onChange={(e) => {
            const v = Number(e.target.value);
            if (!Number.isFinite(v)) return;
            setProp('letterSpacing', Math.max(-0.08, Math.min(0.45, v)));
          }}
        />
        <span className="text-xs text-muted-foreground">em</span>
        <button
          type="button"
          className="text-xs text-primary hover:underline ml-auto"
          onClick={() => setProp('letterSpacing', 0)}
        >
          Réinitialiser
        </button>
      </div>
      <p className="text-[11px] text-muted-foreground leading-relaxed">
        L&apos;aperçu à droite et le canvas se mettent à jour en direct. Valeurs négatives resserrent
        les lettres ; positives les espacent (titres, labels caps…).
      </p>
    </div>
  );
}
